module.exports = __webpack_public_path__ + "static/img/zl_role.0f86420.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/zl_role.png
// module id = hdw6
// module chunks = 7